export default __webpack_public_path__ + "slices/main/assets/public/media/community-pga-image.086a860c443b78db32ddf4391e60c7a6.png";